import dateLib from 'date-and-time';

const formatEventDate = (dateString = '', dateFormat?: string): string => {
	const dateDate = new Date(dateString);
	return dateLib.format(dateDate, dateFormat || 'DD/M');
};

const formatEventTime = (dateString = '', dateFormat?: string): string => {
	const dateDate = new Date(dateString);
	return dateLib.format(dateDate, dateFormat || 'HH:mm');
};

interface FormatEventDateAndTimeOptions {
	hasDateFormat?: boolean;
	hasTimeFormat?: boolean;
}

export const formatEventDateAndTime = (dateString = '', options: FormatEventDateAndTimeOptions = {}): string => {
	const { hasDateFormat = true, hasTimeFormat = true } = options;

	if (hasDateFormat && hasTimeFormat) {
		return `${formatEventDate(dateString)} ${formatEventTime(dateString)}`;
	}
	if (hasDateFormat && !hasTimeFormat) {
		return formatEventDate(dateString);
	}
	if (hasTimeFormat && !hasDateFormat) {
		return formatEventTime(dateString);
	}

	return '';
};

export const formatReportingBetDateAndTime = (betDate: string): string => {
	return `${formatEventDate(betDate, 'DD/MM/YYYY')} - ${formatEventTime(betDate, 'HH:mm')}`;
};

export const addHoursToDate = (date: Date, hours: number): Date => {
	const returnedDate = new Date(date.getTime());
	returnedDate.setHours(returnedDate.getHours() + hours);
	return returnedDate;
};

export const addDaysToDate = (date: Date, days: number): Date => {
	const returnedDate = new Date(date.getTime());
	returnedDate.setDate(returnedDate.getDate() + days);
	return returnedDate;
};

export const addMonthsToDate = (date: Date, months: number): Date => {
	const returnedDate = new Date(date.getTime());
	returnedDate.setMonth(returnedDate.getMonth() + months);
	return returnedDate;
};

export const getFlooredStartDate = (date: Date | string): Date => {
	const time = new Date(date);
	time.setHours(0, 0, 0, 0);
	return time;
};

export const getCeiledEndDate = (date: Date): Date => {
	const time = new Date(date);
	time.setHours(23, 59, 59, 999);
	return time;
};
